import { apiFetch } from '../utils/api';

export interface ProductBrand {
  id: string;
  erpId: number;
  name: string;
  createdAt: string;
  updatedAt: string;
}

export interface PaginatedBrandsResponse {
  data: ProductBrand[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export const fetchProductBrands = (params: {
  page?: number;
  limit?: number;
  search?: string;
} = {}): Promise<PaginatedBrandsResponse> => {
  const searchParams = new URLSearchParams();

  if (params.page) {
    searchParams.set('page', String(params.page));
  }

  if (params.limit) {
    searchParams.set('limit', String(params.limit));
  }

  if (params.search) {
    searchParams.set('search', params.search);
  }

  const query = searchParams.toString();
  return apiFetch<PaginatedBrandsResponse>(
    `/product/brands${query ? `?${query}` : ''}`,
  );
};
